import {useEffect} from 'react';

import {useNavigate, useParams} from 'react-router-dom';

import {Grid} from '@mantine/core';

import {RecordForm} from '../forms/RecordForm';

import {
    FormPageLayout,
    PlatformLoader,
    SimplePageContentWrapper,
    TabbedComponent,
} from '@flexinet/ui-components';
import {Profile} from '../profile/Profile';

import {EditPageNavigation} from '../navigation/EditPageNavigation';
import {useApplication} from '../hooks/useApplication.ts';
import {useApplicationsSelection} from '../hooks/useApplicationsSelection.ts';
import {useEditPageTools} from '../hooks/useEditPageTools';
import {rbacActions} from "../../../config/rbac/actions.ts";
import {useVerifiedPermissions} from '@flexinet/auth-components';
import {IndexPage as ApplicationsAccountsPage} from "../../application-accounts/pages/IndexPage.tsx";
import {IndexPage as ApplicationProductsPage} from "../../application-products/pages/IndexPage.tsx";


export const EditPage = () => {

    const navigate = useNavigate();

    const {allowedActions} = useVerifiedPermissions()

    const {id: applicationId} = useParams();

    if (typeof applicationId === 'undefined') {
        throw new Error('applicationId is required parameter');
    }

    const {
        record: application,
        updateRecord,
    } = useApplication(applicationId);

    const {handleClearSelection} = useApplicationsSelection();

    const {
        mode,
        tools,
    } = useEditPageTools();


    useEffect(() => {
        handleClearSelection();
    // eslint-disable-next-line react-hooks/exhaustive-deps -- mount-only effect: deliberately runs once, adding deps would re-fire it
    }, []);


    const tabs = []
    if (allowedActions.includes(rbacActions.ListApplicationAccounts)) {
        tabs.push({
                      title: 'Accounts',
                      component: <ApplicationsAccountsPage/>
                  })
    }
    if (allowedActions.includes(rbacActions.ListApplicationProducts)) {
        tabs.push({
                      title: 'Products',
                      component: <ApplicationProductsPage/>
                  })
    }

    if (!application) {
        return <PlatformLoader message='Loading application...Please wait'/>;
    }


    return (
        <FormPageLayout
            title={application.name ? application.name : application.id}
            pageNavigation={<EditPageNavigation component={application}/>}
            tools={tools}
        >

            {mode === 'view' ?

                <Grid>
                    <Grid.Col span={{
                        base: 12,
                        lg: 4
                    }}>
                        <Profile
                            record={application}
                        />
                    </Grid.Col>
                    <Grid.Col span={{
                        base: 12,
                        lg: 8
                    }}>
                        <TabbedComponent tabs={tabs}/>
                    </Grid.Col>
                </Grid>

                :
                <SimplePageContentWrapper>
                    <RecordForm
                        record={application}
                        handleSubmit={updateRecord}
                        handleCancel={() => navigate('/applications')}
                    />
                </SimplePageContentWrapper>
            }


        </FormPageLayout>
    );
};
